import type { LeaseActionProps } from '../../../models/Types';

export default function RedirectToLeaseView({ lease, history, terminateActiveAction }: LeaseActionProps) {
  const redirectPath = lease.isSelfUpload ? lease.getSelfServePreviewPath() : lease.getPreviewPath();

  history.push(redirectPath);
  terminateActiveAction();
  return null;
}
